export const APP_VERSION = '4.0.7';
export const BUILD_DATE = new Date().toISOString().split('T')[0];
export const VERSION_INFO = `v${APP_VERSION} (${BUILD_DATE})`;